Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorTokens = void 0;

var natura_1 = require("./natura");

var avon_1 = require("./avon");

var theBodyShop_1 = require("./theBodyShop");
/**
 * @deprecated theme-bound `colorTokens` are deprecated since v0.20 and will be removed at v1.0.
 * Please use `theme.${brand}.${mode}.color` from `natds-themes`.
 */


exports.colorTokens = {
  /**
   * @deprecated `avonDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
   * Please use `theme.avon.dark.color` from `natds-themes`.
   */
  avonDarkColorTokens: avon_1.avonDarkColorTokens,

  /**
   * @deprecated `avonLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
   * Please use `theme.avon.light.color` from `natds-themes`.
   */
  avonLightColorTokens: avon_1.avonLightColorTokens,

  /**
   * @deprecated `naturaDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
   * Please use `theme.natura.dark.color` from `natds-themes`.
   */
  naturaDarkColorTokens: natura_1.naturaDarkColorTokens,

  /**
   * @deprecated `naturaLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
   * Please use `theme.natura.light.color` from `natds-themes`.
   */
  naturaLightColorTokens: natura_1.naturaLightColorTokens,

  /**
   * @deprecated `theBodyShopDarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
   * Please use `theme.theBodyShop.dark.color` from `natds-themes`.
   */
  theBodyShopDarkColorTokens: theBodyShop_1.theBodyShopDarkColorTokens,

  /**
   * @deprecated `theBodyShopLightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
   * Please use `theme.theBodyShop.light.colors` from `natds-themes`.
   */
  theBodyShopLightColorTokens: theBodyShop_1.theBodyShopLightColorTokens
};